import { render } from "./huanxunTaskCenter.vue?vue&type=template&id=59cc481f&scoped=true&ts=true"
import script from "./huanxunTaskCenter.vue?vue&type=script&lang=ts"
export * from "./huanxunTaskCenter.vue?vue&type=script&lang=ts"

import "./huanxunTaskCenter.vue?vue&type=style&index=0&id=59cc481f&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59cc481f"]])

export default __exports__